{
  "name": "@gzl10/nexus-backend",
  "version": "1.0.0-alpha.0",
  "description": "Backend as a Service (BaaS) with Hono, Knex and CASL",
  "type": "module",
  "main": "./dist/index.js",
  "types": "./dist/index.d.ts",
  "bin": {
    "nexus": "./dist/cli.js"
  },
  "exports": {
    ".": {
      "import": "./dist/index.js",
      "types": "./dist/index.d.ts"
    },
    "./testing": {
      "import": "./dist/testing/index.js",
      "types": "./dist/testing/index.d.ts"
    },
    "./migrations": {
      "import": "./dist/migration-helpers/index.js",
      "types": "./dist/migration-helpers/index.d.ts"
    }
  },
  "files": [
    "dist",
    "public",
    "migrations",
    "claude-commands",
    "llms.txt"
  ],
  "license": "MIT",
  "author": "Gonzalo Díez <gonzalo@gzl10.com>",
  "homepage": "https://gitlab.gzl10.com/oss/nexus",
  "repository": {
    "type": "git",
    "url": "https://gitlab.gzl10.com/oss/nexus.git",
    "directory": "packages/backend"
  },
  "bugs": {
    "url": "https://gitlab.gzl10.com/oss/nexus/-/issues"
  },
  "funding": {
    "type": "buymeacoffee",
    "url": "https://www.buymeacoffee.com/gzl10g"
  },
  "engines": {
    "node": ">=20.0.0"
  },
  "keywords": [
    "baas",
    "backend",
    "backend-as-a-service",
    "hono",
    "api",
    "rest",
    "knex",
    "sqlite",
    "postgresql",
    "mysql",
    "casl",
    "authorization",
    "authentication",
    "jwt"
  ],
  "scripts": {
    "dev": "node --watch-path=./src --import tsx/esm src/main.ts",
    "build": "tsup",
    "start": "node dist/main.js",
    "nexus": "tsx src/cli.ts",
    "typecheck": "tsc --noEmit",
    "lint": "eslint src tests",
    "test": "vitest run",
    "test:watch": "vitest",
    "test:coverage": "vitest run --coverage",
    "clean": "rm -rf dist node_modules coverage"
  },
  "dependencies": {
    "@aws-sdk/client-s3": "^3.1006.0",
    "@aws-sdk/s3-request-presigner": "^3.1006.0",
    "@casl/ability": "^6.8.0",
    "@gzl10/nexus-client": "workspace:^",
    "@gzl10/nexus-sdk": "workspace:*",
    "@hono/node-server": "^1.19.13",
    "@hono/otel": "^1.1.1",
    "@hono/swagger-ui": "^0.6.1",
    "@hono/zod-openapi": "^0.19.10",
    "@hono/zod-validator": "^0.7.6",
    "@opentelemetry/api": "^1.9.0",
    "@opentelemetry/exporter-prometheus": "^0.213.0",
    "@opentelemetry/exporter-trace-otlp-http": "^0.213.0",
    "@opentelemetry/instrumentation-http": "^0.213.0",
    "@opentelemetry/instrumentation-knex": "^0.57.0",
    "@opentelemetry/instrumentation-pino": "^0.59.0",
    "@opentelemetry/instrumentation-runtime-node": "^0.27.0",
    "@opentelemetry/sdk-node": "^0.213.0",
    "@paralleldrive/cuid2": "^2.2.2",
    "@sentry/node": "^10.43.0",
    "bcryptjs": "^2.4.3",
    "better-sqlite3": "^11.0.0",
    "cli-table3": "^0.6.5",
    "commander": "^14.0.3",
    "consola": "^3.4.2",
    "cron-parser": "^5.5.0",
    "dotenv": "^17.3.1",
    "eventemitter2": "^6.4.9",
    "hono": "^4.12.12",
    "ioredis": "^5.10.0",
    "jsonwebtoken": "^9.0.3",
    "knex": "^3.1.0",
    "mysql2": "^3.19.1",
    "nanoid": "^5.1.5",
    "node-cron": "^4.2.1",
    "node-machine-id": "^1.1.12",
    "nodemailer": "^7.0.13",
    "ofetch": "^1.5.1",
    "pg": "^8.20.0",
    "pino": "^10.3.1",
    "sharp": "^0.34.5",
    "socket.io": "^4.8.3",
    "ulidx": "^2.4.1",
    "zod": "^3.24.0"
  },
  "devDependencies": {
    "@types/bcryptjs": "^2.4.0",
    "@types/jsonwebtoken": "^9.0.10",
    "@types/node-cron": "^3.0.11",
    "@types/nodemailer": "^7.0.11",
    "@types/supertest": "^6.0.3",
    "pino-pretty": "^13.1.3",
    "socket.io-client": "^4.8.3",
    "supertest": "^7.2.2",
    "tsx": "^4.21.0",
    "vite": "^8.0.3"
  },
  "peerDependencies": {
    "vite": ">=6.0.0",
    "vitest": ">=3.0.0"
  },
  "peerDependenciesMeta": {
    "vite": {
      "optional": true
    },
    "vitest": {
      "optional": true
    }
  },
  "publishConfig": {
    "access": "public",
    "registry": "https://registry.npmjs.org"
  }
}
